import * as React from "react";
import { Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

const Home = (props: IIconProps) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.494 7.83c1.839-1.654 6.426-5.58 8.725-5.58 2.31 0 6.83 3.926 8.703 5.58.662.587 1.133 1.35 1.177 2.21.157 3.297-.1 6.888-.785 10.134-.09.346-.28.67-.55.932a2.369 2.369 0 0 1-.964.597c-1.054.22-2.299.429-3.14.534-.841.115-1.435-.524-1.435-1.372.044-.806.112-2.9.145-4.596.023-1.173-.987-2.136-2.243-2.136h-1.85c-1.268 0-2.277.974-2.243 2.157.056 1.696.112 3.79.112 4.565.09.858-.482 1.497-1.436 1.371a42.127 42.127 0 0 1-3.039-.534 2.571 2.571 0 0 1-1.01-.576 2.062 2.062 0 0 1-.582-.942 41.448 41.448 0 0 1-.785-10.114c.044-.869.527-1.633 1.2-2.23ZM13 11a1.001 1.001 0 0 1-2 0 1.001 1.001 0 0 1 2 0Z"
      fill="currentColor"
    />
  </Icon>
);

export default Home;
